exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal {\n  width: 620px;\n  overflow: visible; }\n\n.modal h4 {\n  margin-left: -2px; }\n\n.modal .modal-content {\n  padding-bottom: 0; }\n\n.modal .modal-footer {\n  margin-bottom: 10px; }\n\n.modal .modal-footer .btn-abort {\n  margin-right: 5px; }\n\n.modal .modal-footer .btn-ok {\n  margin-left: 5px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agir/src/app/components/confirm-sync/confirm-sync.component.scss
// module id = ../../../../../src/app/components/confirm-sync/confirm-sync.component.scss
// module chunks = main